import script from "./CompetitionFixturesOld.vue?vue&type=script&setup=true&lang=js"
export * from "./CompetitionFixturesOld.vue?vue&type=script&setup=true&lang=js"

import "./CompetitionFixturesOld.vue?vue&type=style&index=0&id=ae055536&scoped=true&lang=css"
import "./CompetitionFixturesOld.vue?vue&type=style&index=1&id=ae055536&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ae055536"]])

export default __exports__